/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the SDHouseholdMemberRenewalStatusDtls
 *
 * @class SDHouseholdMemberRenewalStatusDtls
 */
class SDHouseholdMemberRenewalStatusDtls {
  /**
   * Creates an instance of SDHouseholdMemberRenewalStatusDtls.
   * @param {*} json
   * @memberof SDHouseholdMemberRenewalStatusDtls
   */
  constructor(json = null) {
    if (json) {
      // string
      this.firstForeName = json.firstForeName;

      // string
      this.otherForeName = json.otherForeName;

      // string
      this.surname = json.surname;

      // string
      this.secondLastSurname = json.secondLastSurname;

      // string
      this.deadlineDate = json.deadlineDate;

      // string
      this.renewalStatus = json.renewalStatus;

      // string
      this.sdccaProgramName = json.sdccaProgramName;
    }
  }
}

/**
 * Models the SDExternalUserRenewalStatus
 *
 * @class SDExternalUserRenewalStatus
 */
class SDExternalUserRenewalStatus {
  /**
   * Creates an instance of SDExternalUserRenewalStatus.
   * @param {*} json
   * @memberof SDExternalUserRenewalStatus
   */
  constructor(json = null) {
    if (json) {
      // string
      this.lastUpdated = json.lastUpdated;

      // string
      this.maLastUpdated = json.maLastUpdated;

      // string
      this.ccaLastUpdated = json.ccaLastUpdated;

      // string
      this.renewalDeadline = json.renewalDeadline;

      // boolean
      this.isRenewalInProgress = json.isRenewalInProgress;

      // boolean
      this.isDueRenewal = json.isDueRenewal;

      // boolean
      this.isDueCCARenewal = json.isDueCCARenewal;

      // boolean
      this.isDueMARenewal = json.isDueMARenewal;

      // string
      this.applicationFormID = json.applicationFormID;

      // string
      this.ccaApplicationFormID = json.ccaApplicationFormID;

      // string
      this.maApplicationFormID = json.maApplicationFormID;

      // boolean
      this.isWithinRecertPeriod = json.isWithinRecertPeriod;

      // boolean
      this.isCCARenewalInProgress = json.isCCARenewalInProgress;

      // boolean
      this.isMARenewalInProgress = json.isMARenewalInProgress;

      // array - SDHouseholdMemberRenewalStatusDtls
      if (json.dtls) {
        this.dtls = json.dtls.map(object => new SDHouseholdMemberRenewalStatusDtls(object));
      } else if (json.constructor === Array) {
        this.dtls = json.map(object => new SDHouseholdMemberRenewalStatusDtls(object));
      }
    }
  }
}

/**
 * Models the UAApplicationFormIdentifier
 *
 * @class UAApplicationFormIdentifier
 */
class UAApplicationFormIdentifier {
  /**
   * Creates an instance of UAApplicationFormIdentifier.
   * @param {*} json
   * @memberof UAApplicationFormIdentifier
   */
  constructor(json = null) {
    if (json) {
      // string
      this.application_form_id = json.application_form_id;

      // boolean
      this.isPartialApplication = json.isPartialApplication;
    }
  }
}

export default {
  SDHouseholdMemberRenewalStatusDtls,

  SDExternalUserRenewalStatus,

  UAApplicationFormIdentifier,
};
